import React, { useRef, useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { products } from '../assets/data/products';

const Products = () => {
  const scrollRef = useRef(null);
  const [activeCategory, setActiveCategory] = useState('Standard Wipers');
  const [selectedProduct, setSelectedProduct] = useState(null); 

  const categories = [
    "Standard Wipers",
    "Hybrid Wipers",
    "Flat / Beam Wipers",
    "Wiper Refills"
  ];

  const filteredProducts = products.filter(
    (product) => product.category === activeCategory
  );

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = 350;
      current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id='products' className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-10">
          <h2 className="text-3xl font-extrabold text-black">
            We have the best quality products
          </h2>
          <div className="hidden md:flex space-x-4">
            <button 
              onClick={() => scroll('left')} 
              className="p-2 px-6 rounded-full border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white transition-all duration-300 hover:scale-105"
            >
              ◀
              {/* <ArrowLeft size={24} /> */}
            </button>
            <button 
              onClick={() => scroll('right')} 
              className="p-2 px-6 rounded-full border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white transition-all duration-300 hover:scale-105"
            >
              ▶
              {/* <ArrowRight size={24} /> */}
            </button>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="w-full lg:w-1/4">
            <div className="bg-transparent border-l border-gray-300">
              {categories.map((cat, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCategory(cat)}
                  className={`w-full text-left px-6 py-4 text-sm font-bold transition-all border-l-4 -ml-[1px] ${
                    activeCategory === cat 
                      ? "border-blue-700 text-blue-800 bg-white shadow-sm" 
                      : "border-transparent text-gray-600 hover:text-black"
                  }`}
                >{cat}
                </button>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-3/4 overflow-hidden relative">
            <div 
              ref={scrollRef}
              className="flex overflow-x-auto gap-6 pb-8 snap-x scrollbar-hide"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {filteredProducts.length === 0 ? (
                <p className="text-gray-600 ml-6 mt-4">No products in this category.</p>
              ) : (
                filteredProducts.map((product) => (
                  <div
                    key={product.id}
                    onClick={() => setSelectedProduct(product)} 
                    className="min-w-[300px] md:min-w-[340px] bg-white rounded-3xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col items-center text-center group snap-center border-t-4 border-transparent hover:border-blue-600 cursor-pointer"
                  >
                    <div className="h-48 w-full mb-6 flex items-center justify-center overflow-hidden rounded-lg">
                      <img 
                        src={product.image} 
                        alt={product.name} 
                        className="h-full w-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <h3 className="text-2xl font-black text-blue-700 mb-2 uppercase italic tracking-wide">
                      {product.name}
                    </h3>
                    <p className="text-gray-500 text-sm font-medium px-4">
                      {product.desc}
                    </p>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

      {selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="bg-white rounded-2xl max-w-2xl w-full p-6 relative">
            <button
              onClick={() => setSelectedProduct(null)}
              className="absolute top-4 right-4 text-gray-600 hover:text-black font-bold text-xl"
            > ×
            </button>

            <div className="flex flex-col md:flex-row gap-6">
              <img 
                src={selectedProduct.image} 
                alt={selectedProduct.name} 
                className="w-full md:w-1/2 h-64 object-contain rounded-lg"
              />
              <div className="flex-1">
                <h2 className="text-2xl font-bold text-blue-700">{selectedProduct.name}</h2>
                <p className="mt-4 text-gray-700">{selectedProduct.desc}</p>
                {selectedProduct.height && <p className="mt-2"><strong>Height:</strong> {selectedProduct.height}</p>}
                {selectedProduct.material && <p className="mt-2"><strong>Material:</strong> {selectedProduct.material}</p>}
                {selectedProduct.weight && <p className="mt-2"><strong>Weight:</strong> {selectedProduct.weight}</p>}
                {selectedProduct.usage && <p className="mt-2"><strong>Usage:</strong> {selectedProduct.usage}</p>}
                
                <a
                  href={`https://wa.me/919891451698?text=Hello!%20I%20am%20interested%20in%20the%20product%20"${encodeURIComponent(selectedProduct.name)}".%20Could%20you%20please%20share%20the%20price%3F`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-block bg-blue-700 hover:bg-blue-800 text-white font-bold px-6 py-3 rounded-full transition-all duration-300 hover:scale-105"
                >Enquire On <i className="fa-brands fa-whatsapp"></i>
                </a>

              </div>
            </div>
          </div>
        </div>
      )}

      </div>
    </section>
  );
};

export default Products;